import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../store/slices/auth";
import staffReducer from "../store/slices/staff";
import classsectionReducer from "../store/slices/getstandardsection";
import noticeReducer from "../store/slices/notice";
import classteacherReducer from "../store/slices/classteacher";
import subjectReducer from "../store/slices/subject";
import subjectTeacherReducer from "../store/slices/subjectteacher";
import classandsectionReducer from "../store/slices/classandsection";
import feesReducer from "../store/slices/fees";
import homeworkReducer from "../store/slices/homework";
import attendencereducer from "../store/slices/attendence";
import activityReducer from "../store/slices/activity";
import activestudentreducer from "./slices/activestudent";
import examReducer from "./slices/exam";
import setmarksReducer from "./slices/setmarks"
import studenrreducer from "./slices/student";
import expensereducer from "./slices/expense";
import resultreducer from "./slices/result";

const rootReducer = combineReducers({
  auth: authReducer,
  staff: staffReducer,
  classsection: classsectionReducer,
  notice: noticeReducer,
  classteacher: classteacherReducer,
  subject: subjectReducer,
  subjectTeacher: subjectTeacherReducer,
  classandsection: classandsectionReducer,
  fees: feesReducer,
  homework: homeworkReducer,
  attendence: attendencereducer,
  activity: activityReducer,
  activestudent: activestudentreducer,
  exam: examReducer,
  setmarks: setmarksReducer,
  student: studenrreducer,
  expense: expensereducer,
  result: resultreducer,

});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});
export default store;
